import axios from 'axios'
import store from '@/store'
import storage from '@/storage'
import router from '@/router/index'
import { Message } from 'element-ui'
import i18n from '@/lang'

// axios.defaults.withCredentials = true; // 是否跨域

export const service = axios.create({
  // baseURL: NEW_API, // api的base_url // 使用反向代理baseURL必须 不设置
  timeout: 100000// request timeout
})

// 增加请求拦截器
service.interceptors.request.use(function (config) {
  store.dispatch('showLoading')

  // deal token
  let token = storage.get_token()
  config.headers['Authorization'] = token

  return config
}, function (error) {
  console.log('request error:', error)
  return Promise.reject(error)
})

// 增加一个response拦截器
service.interceptors.response.use(function (response, res) {
  store.dispatch('hideLoading')
  return response
}, function (error) {
  store.dispatch('hideLoading')

  let res = error.response
  if (res && res.status === 401) {
    Message.error({message: i18n.t('message.something_failed', { msg: i18n.t('name.authorization') })})
    router.push({ name: 'login' })
  // return Promise.reject(error)
  } else {
    console.log('response error:', error)
    Message.error({message: res.data, duration: 5000})
    // Message.error({message: '数据请求失败，请重试!(' + res.data + ')'})
  }

  // return res
  // return Promise.reject(resp)
  return Promise.reject(error)
})

export let apiObj = (obj) => {
  let url = ''
  for (let key in obj) {
    if (url.indexOf('?') === -1) {
      url += '?' + key + '=' + encodeURIComponent(obj[key])
    } else {
      url += '&' + key + '=' + encodeURIComponent(obj[key])
    }
  }
  return url
}



// WEBPACK FOOTER //
// ./src/api/request.js